import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: "", // you can store any string here
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.message = action.payload; // expects a string
    },
    clearNotification: (state) => {
      state.message = "";
    },
  },
});

export const { setNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;